import { browserLocalStorage } from "@base/browserLocalStorage";

/** The checkout session's header. The token never goes in a URL or a log. */
export const CHECKOUT_TOKEN_HEADER = "x-nt-checkout";
/** Carries the one-time jump token to the checkout origin. */
export const JUMP_TOKEN_PARAM = "ct";

function write(update: { checkoutToken?: string | null; checkoutEmail?: string | null }) {
  browserLocalStorage.set({ ...browserLocalStorage.get(), ...update });
}

export function getCheckoutToken(): string | null {
  return browserLocalStorage.get().checkoutToken ?? null;
}

/** A new session: an email sorted under the old one no longer counts. */
export function setCheckoutToken(checkoutToken: string) {
  write({ checkoutToken, checkoutEmail: null });
}

export function clearCheckoutToken() {
  write({ checkoutToken: null, checkoutEmail: null });
}

export function getCheckoutEmail(): string | null {
  return browserLocalStorage.get().checkoutEmail ?? null;
}

export function setCheckoutEmail(email: string) {
  write({ checkoutEmail: email.trim().toLowerCase() });
}

export function checkoutHeaders(): Record<string, string> {
  const token = getCheckoutToken();
  return token ? { [CHECKOUT_TOKEN_HEADER]: token } : {};
}

let arrivalJumpToken: string | null = null;

/** Reads `?ct=` at pageload. The address bar is cleaned later. */
export function takeJumpTokenFromURL() {
  if (typeof window === "undefined") return;
  const token = new URL(window.location.href).searchParams.get(JUMP_TOKEN_PARAM);
  if (token) arrivalJumpToken = token;
}

/**
 * Takes `?ct=` off the address bar. Must run after Gatsby's first render:
 * Gatsby looks the page up by the URL it started with, so changing it earlier
 * leaves the page blank.
 */
export function removeJumpTokenFromURL() {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  if (!url.searchParams.has(JUMP_TOKEN_PARAM)) return;
  url.searchParams.delete(JUMP_TOKEN_PARAM);
  window.history.replaceState(window.history.state, "", url.toString());
}

/** The jump token this pageload arrived with. Returns it once. */
export function takeArrivalJumpToken(): string | null {
  const token = arrivalJumpToken;
  arrivalJumpToken = null;
  return token;
}
